import { useContext } from "react";

import { FormStepContext } from "../context/FormStepContext";

export const useFormStep = () => useContext(FormStepContext);
